import { getStrategiesGrouped } from '@/api/strategies'
import Vue from 'vue'

const state = {
  groupedStrategies: {},
  guidelineMappings: {},
  principleMappings: {
    I: 'Representation',
    II: 'Action & Expression',
    III: 'Engagement'
  },
  fetching: false,
  _alreadyFetched: false,
  eventHub: new Vue()
}

export const mutations = {
  setGroupedStrategies(state, payload) {
    state.groupedStrategies = payload.adaptations
    state.guidelineMappings = payload.guideline_mappings
    state._alreadyFetched = true
  },
  setFetching(state, flag) {
    state.fetching = flag
  }
}

export const actions = {
  async getUdlIndexStrategies({ commit, state }) {
    if (state._alreadyFetched) {
      return state.groupedStrategies
    } else {
      commit('setFetching', true)
      try {
        let payload = await getStrategiesGrouped()
        commit('setGroupedStrategies', payload)
        commit('setFetching', false)

        return payload.adaptations
      } catch (err) {
        commit('setFetching', false)
        throw 'Error retrieving UDL strategies'
      }
    }
  }
}

export const getters = {
  guidelinesForPrinciple(state) {
    return principleNum => {
      return Object.keys(state.groupedStrategies[principleNum])
        .sort()
        .map(key => ({
          label: state.guidelineMappings[key].replace(/(Provide|Design) options for /g, ''),
          checkpoints: state.groupedStrategies[principleNum][key]
        }))
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
